export const GAME_CONFIG_ID = "0x"
export const MaterialIdNone = "0x0000000000000000000000000000"
